import { makeStyles } from 'tss-react/mui';

import { svgIconClasses } from '@mui/material';

export default makeStyles({ name: 'BulletinTypes' })({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 32
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    title: {
        margin: 0,
        color: '#232323',
        fontSize: 24,
        fontWeight: 700,
        lineHeight: '150%',
        ['& a']: {
            textDecoration: 'none',
            color: '#F5726A'
        }
    },
    bulletins: {
        display: 'grid',
        gap: 24,
        gridTemplateColumns: 'repeat(3, 1fr)',
        alignItems: 'stretch',
        ['@media (max-width: 960px)']: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 24,
            width: '100%'
        }
    },
    bulletin: {
        ['@media (max-width: 960px)']: {
            width: '100%'
        }
    },
    button: {
        padding: '12px 16px',
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px',
        borderRadius: 12,
        border: '1px solid #ECECEC',
        [`&& .${svgIconClasses.root}`]: {
            fontSize: 16
        }
    }
});
